























































































































































































import '@/extensions';
import Http from '@/mixins/http';
import LocalData from '@/mixins/local-data';
import {Component, Mixins, Prop} from 'vue-property-decorator';
import MultiSelect from "@/components/MultiSelect.vue";
import {SelectBox} from "@/interfaces/global-data";
import {GetTaskInfo, ProductInfoResponseProperty, TaskInfoFilterType, UserShortInfo} from "@/interfaces/server-data";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import {
  AggregatedModuleReportModalFilters,
  CreateAggregatedModuleReportPayloadParams,
  CreateAggregatedPromotionsReportPayloadParams,
  EntityFilterKeys,
  EntityMaskOptions,
  ModuleType,
  TaskTypeEntityProperties,
  TModuleType
} from "@/pages/ModuleItems/data";

@Component({
  computed: {
    TaskInfoFilterType() {
      return TaskInfoFilterType;
    }
  },
  components: {
    MultiSelect,
    DatePicker,
  },
})
export default class CreateAggregatedReportUniversalModal extends Mixins(LocalData, Http) {
  @Prop({required: true}) readonly isModalVisible!: boolean;
  @Prop({required: true}) readonly moduleType!: TModuleType;
  @Prop({ default: () => [] }) readonly reportStatusOptions!: Array<SelectBox<string>>;

  defaultIntSelectBox: Array<SelectBox<number>> = [{value: 0, label: this.$t('shared.selectBox.all') as string}];
  isCreateBtnLoading: boolean = false;

  modalFilters: AggregatedModuleReportModalFilters = {
    groupIds: [],
    categoryIds: [],
    subcategoryIds: [],
    formatIds: [],
    regionIds: [],
    clusterIds: [],
    userIds: [0],
    dates: [],
    types: ['ALL'],
    statuses: ['ALL'],
    reportStatuses: ['ALL'],
  };

  modalFiltersOptions: EntityMaskOptions = {
    groups: [],
    categories: [],
    subcategories: [],
    formats: [],
    regions: [],
    clusters: [],
  };

  modalUsersOptions: Array<SelectBox<number>> = [{value: 0, label: this.$t('shared.selectBox.all') as string}];

  modalFilterOptionPropertyNames: TaskTypeEntityProperties = {
    group: 'groups',
    category: 'categories',
    subcategory: 'subcategories',
    format: 'formats',
    region: 'regions',
    cluster: 'clusters',
  };

  modalFiltersPropertyNames: TaskTypeEntityProperties = {
    group: 'groupIds',
    category: 'categoryIds',
    subcategory: 'subcategoryIds',
    format: 'formatIds',
    region: 'regionIds',
    cluster: 'clusterIds',
  };

  get moduleTypeOptions(): Array<SelectBox<string>> {
    return this.moduleItemTypeOptions[this.moduleType] || [];
  }

  get moduleStatusOptions(): Array<SelectBox<string>> {
    return this.moduleItemStatusOptions[this.moduleType] || [];
  }

  get moduleTypeLabel(): string {
    return this.moduleType === ModuleType.PROMO
      ? this.$t('promo.promoType') as string
      : this.$tc('sales.type') as string;
  }

  get moduleStatusLabel(): string {
    return this.moduleType === ModuleType.PROMO
      ? this.$t('shared.labels.promoStatus') as string
      : this.$t('shared.labels.saleStatus') as string;
  }

  get modalTitle(): string {
    return this.moduleType === ModuleType.PROMO
      ? this.$t('shared.aggregatedReport.promoTitle') as string
      : this.$t('shared.aggregatedReport.title') as string;
  }

  get moduleData() {
    return this.moduleType === ModuleType.PROMO ? this.$promotions : this.$sales;
  }

  mounted() {
    this.fetchModalSelectsOptions(TaskInfoFilterType.group, 'modalGroupsSelectRef');
    this.fetchModalSelectsOptions(TaskInfoFilterType.category, 'modalCategoriesSelectRef');
    this.fetchModalSelectsOptions(TaskInfoFilterType.subcategory, 'modalSubcategoriesSelectRef');
    this.fetchModalSelectsOptions(TaskInfoFilterType.format, 'modalFormatsSelectRef');
    this.fetchModalSelectsOptions(TaskInfoFilterType.region, 'modalRegionsSelectRef');
    this.fetchModalSelectsOptions(TaskInfoFilterType.cluster, 'modalClustersSelectRef');
    this.fetchModalUsersOptions();
  }


  fetchModalUsersOptions() {
    this.$nextTick(() => {
      if (this.$refs.modalUsersSelectRef) {
        (this.$refs.modalUsersSelectRef as any).toggleLoading(true);
      }
    });

    this.httpFetchUsersShortInfoList()
      .then((response) => {
        const users: UserShortInfo[] = response.data || [];
        const sortedOptions = users
          .map((user) => ({
            value: user.id,
            label: (user.fio && user.fio.trim()) || user.username || `#${user.id}`,
          }))
          .sort((a, b) => a.label.localeCompare(b.label));

        this.modalUsersOptions = [
          {value: 0, label: this.$t('shared.selectBox.all') as string},
          ...sortedOptions,
        ];
      })
      .catch(() => {
        this.modalUsersOptions = [{value: 0, label: this.$t('shared.selectBox.all') as string}];
        this.modalFilters.userIds = [0];

        this.showError(this.$t('shared.aggregatedReport.errorLoadUsers') as string);
      })
      .finally(() => {
        if (this.$refs.modalUsersSelectRef) {
          (this.$refs.modalUsersSelectRef as any).toggleLoading(false);
        }
      });
  }

  handleModalUsersChanged(value: number[]) {
    if (!!value.length && !LocalData.compareTwoArrays(value, this.modalFilters.userIds)) {
      this.modalFilters.userIds = value.realValuesOrEmpty().length ? value : [0];
    }
  }

  closeModal() {
    this.$emit('close-modal');
  }

  hideModal() {
    this.$emit('hide-modal');
  }

  private get isCreateReportBtnDisabled() {
    return !this.modalFilters.dates.filter(date => !!date).length;
  }

  handleModalFiltersChanged(value: number[], type: EntityFilterKeys) {
    if (!!value.length && !LocalData.compareTwoArrays(value, this.modalFilters[this.modalFiltersPropertyNames[type] as keyof AggregatedModuleReportModalFilters] as number[])) {
      this.modalFilters[this.modalFiltersPropertyNames[type] as keyof AggregatedModuleReportModalFilters] = value.realValuesOrEmpty();
      this.updateModalFiltersData(type);
    }
  }

  handleModalParamMultiselectValueChanged(value: string[], key: 'statuses' | 'types' | 'reportStatuses', optionsWithoutAllLength: number = 0) {
    if (!!value.length) {
      if ((value.length === 1 && value[0] === 'ALL') || value[value.length - 1] === 'ALL') {
        this.modalFilters[key] = ['ALL'];
      } else {
        const arrRes = value.filter(value => value !== 'ALL');
        this.modalFilters[key] = arrRes.length === optionsWithoutAllLength ? ['ALL'] : arrRes;
      }
    } else {
      this.modalFilters[key] = ['ALL'];
    }
  }

  private getLoadOptionsFilter(taskType: EntityFilterKeys): GetTaskInfo {
    switch (taskType) {
      case TaskInfoFilterType.group:
        return {
          type: taskType,
          tradingId: this.moduleData.selectMarket.id,
          groups: [],
          categories: [],
          subcategory: [],
          storeFormat: [],
          storeRegion: [],
          storeCluster: [],
          productSegments: null,
          segments: null,
          byReports: false,
        };
      case TaskInfoFilterType.category:
        return {
          type: taskType,
          tradingId: this.moduleData.selectMarket.id,
          groups: this.modalFilters.groupIds.realValuesOrEmpty(),
          categories: [],
          subcategory: [],
          storeFormat: [],
          storeRegion: [],
          storeCluster: [],
          productSegments: null,
          segments: null,
          byReports: false,
        };
      case TaskInfoFilterType.subcategory:
        return {
          type: taskType,
          tradingId: this.moduleData.selectMarket.id,
          groups: this.modalFilters.groupIds.realValuesOrEmpty(),
          categories: this.modalFilters.categoryIds.realValuesOrEmpty(),
          subcategory: [],
          storeFormat: [],
          storeRegion: [],
          storeCluster: [],
          productSegments: null,
          segments: null,
          byReports: false,
        };
      case TaskInfoFilterType.format:
        return {
          type: taskType,
          tradingId: this.moduleData.selectMarket.id,
          groups: [],
          categories: [],
          subcategory: [],
          storeFormat: [],
          storeRegion: [],
          storeCluster: [],
          productSegments: null,
          segments: null,
          byReports: false,
        };
      case TaskInfoFilterType.region:
        return {
          type: taskType,
          tradingId: this.moduleData.selectMarket.id,
          groups: [],
          categories: [],
          subcategory: [],
          storeFormat: this.modalFilters.formatIds.realValuesOrEmpty(),
          storeRegion: [],
          storeCluster: [],
          productSegments: null,
          segments: null,
          byReports: false,
        };
      case TaskInfoFilterType.cluster:
        return {
          type: taskType,
          tradingId: this.moduleData.selectMarket.id,
          groups: [],
          categories: [],
          subcategory: [],
          storeFormat: this.modalFilters.formatIds.realValuesOrEmpty(),
          storeRegion: this.modalFilters.regionIds.realValuesOrEmpty(),
          storeCluster: [],
          productSegments: null,
          segments: null,
          byReports: false,
        };
    }
  }

  fetchModalSelectsOptions(type: EntityFilterKeys, refValue: string) {
    this.$nextTick(() => {
      if (this.$refs[refValue]) {
        (this.$refs[refValue] as any).toggleLoading(true);
      }
    });

    this.httpGetProductInfo(this.getLoadOptionsFilter(type))
      .then(data => {
        const options = data.data ? data.data[ProductInfoResponseProperty[type]] : [];
        this.modalFiltersOptions[this.modalFilterOptionPropertyNames[type] as keyof EntityMaskOptions] = options.length
          ? [{ value: 0, label: this.$t('shared.selectBox.all') as string }, ...options.map((i) => ({ value: i.id, label: i.name }))]
          : [{ value: 0, label: this.$t('shared.selectBox.all') as string }];
      })
      .catch(() => {
        this.modalFiltersOptions[this.modalFilterOptionPropertyNames[type] as keyof EntityMaskOptions] = [{ value: 0, label: this.$t('shared.selectBox.all') as string }];
        this.showError(this.$t('shared.aggregatedReport.errorLoadOptions') as string);
      }).finally(() => {
      if (this.$refs[refValue]) {
        (this.$refs[refValue] as any).toggleLoading(false);
      }
    });
  }

  updateModalFiltersData(type: EntityFilterKeys) {
    const defaultMultiSelectValue: number[] = this.defaultIntSelectBox.map(i => i.value);

    switch (type) {
      case TaskInfoFilterType.group:
        this.fetchModalSelectsOptions(TaskInfoFilterType.category, 'modalCategoriesSelectRef');
        this.modalFilters.categoryIds = [...defaultMultiSelectValue];
        this.fetchModalSelectsOptions(TaskInfoFilterType.subcategory, 'modalSubcategoriesSelectRef');
        this.modalFilters.subcategoryIds = [...defaultMultiSelectValue];
        break;
      case TaskInfoFilterType.category:
        this.fetchModalSelectsOptions(TaskInfoFilterType.subcategory, 'modalSubcategoriesSelectRef');
        this.modalFilters.subcategoryIds = [...defaultMultiSelectValue];
        break;
      case TaskInfoFilterType.format:
        this.fetchModalSelectsOptions(TaskInfoFilterType.region, 'modalRegionsSelectRef');
        this.modalFilters.regionIds = [...defaultMultiSelectValue];
        this.fetchModalSelectsOptions(TaskInfoFilterType.cluster, 'modalClustersSelectRef');
        this.modalFilters.clusterIds = [...defaultMultiSelectValue];
        break;
      case TaskInfoFilterType.region:
        this.fetchModalSelectsOptions(TaskInfoFilterType.cluster, 'modalClustersSelectRef');
        this.modalFilters.clusterIds = [...defaultMultiSelectValue];
        break;
    }
  }

  private filterAllValue(values: string[]): string[] {
    return values.includes('ALL') ? [] : values;
  }

  handleCreateReport() {
    this.isCreateBtnLoading = true;

    const sharedPayload = {
      tradingId: this.moduleData.selectMarket.id,
      groups: this.modalFilters.groupIds.realValuesOrEmpty(),
      categories: this.modalFilters.categoryIds.realValuesOrEmpty(),
      subcategories: this.modalFilters.subcategoryIds.realValuesOrEmpty(),
      storeFormats: this.modalFilters.formatIds.realValuesOrEmpty(),
      storeRegions: this.modalFilters.regionIds.realValuesOrEmpty(),
      storeClusters: this.modalFilters.clusterIds.realValuesOrEmpty(),
      userIds: this.modalFilters.userIds.realValuesOrEmpty(),
      startDate: this.modalFilters.dates[0],
      endDate: this.modalFilters.dates[1],
    };

    const moduleSpecificPayload = this.moduleType === ModuleType.PROMO
      ? {
        promotionTypes: this.filterAllValue(this.modalFilters.types),
        promotionStatuses: this.filterAllValue(this.modalFilters.statuses),
      }
      : {
        saleTypes: this.filterAllValue(this.modalFilters.types),
        saleStatuses: this.filterAllValue(this.modalFilters.statuses),
      };

    this.httpCreateAggregatedReport(this.moduleType, {
      ...sharedPayload,
      ...moduleSpecificPayload,
      resultStatus: this.filterAllValue(this.modalFilters.reportStatuses),
    } as CreateAggregatedModuleReportPayloadParams | CreateAggregatedPromotionsReportPayloadParams)
      .then(() => {
        this.showInfo(this.$t('shared.aggregatedReport.successStartReport') as string, 5);
        this.closeModal();
      }).catch(() => {
        this.showError(this.$t('shared.aggregatedReport.errorStartReport') as string);
      }).finally(() => {
      this.isCreateBtnLoading = false;
    });
  }
}
